module.exports = __webpack_public_path__ + "static/img/ikonaPaint.426e8c32.jpg";